import { i18n } from "../../../i18n/i18n";
import { namespaces } from "../../../i18n/i18n.constants";
import { InvoiceStatus } from "../../../app/enums/invoiceStatus";
import { InvoiceResponse } from "../../../app/models/api/invoice/invoiceResponse";
import { InvoiceTableView } from "../../../app/models/api/invoice/invoiceTableView";
import { dateDayMonthYearFormatter } from "../../../services/format/time";

export const invoiceStatusMapper = (status: InvoiceStatus) => {
    switch (status) {
        case InvoiceStatus.Unpaid:
            return i18n.t("invoices.status.unpaid", { ns: namespaces.userAdminPanel });
        case InvoiceStatus.PartiallyPaid:
            return i18n.t("invoices.status.partiallyPaid", { ns: namespaces.userAdminPanel });
        case InvoiceStatus.Paid:
            return i18n.t("invoices.status.paid", { ns: namespaces.userAdminPanel });
        case InvoiceStatus.Cancelled:
            return i18n.t("invoices.status.cancelled", { ns: namespaces.userAdminPanel });
        default:
            return i18n.t("invoices.status.unpaid", { ns: namespaces.userAdminPanel });
    }
};

export const invoiceStatusColorMapper = (status: InvoiceStatus) => {
    switch (status) {
        case InvoiceStatus.Unpaid:
            return "#dc3545"; // red
        case InvoiceStatus.PartiallyPaid:
            return "#fd7e14"; // orange
        case InvoiceStatus.Paid:
            return "#198754"; // green
        case InvoiceStatus.Cancelled:
            return "#6c757d"; // gray
        default:
            return "#000000"; // black
    }
};

export const mapInvoiceResponseToTable = (invoice: InvoiceResponse): InvoiceTableView => ({
    id: invoice.id,
    fileName: invoice.fileName,
    invoiceNumber: invoice.invoiceNumber,
    orderNumber: invoice.orderNumber,
    seller: invoice.seller,
    invoiceDate: dateDayMonthYearFormatter(new Date(invoice.invoiceDate)),
    dueDate: dateDayMonthYearFormatter(new Date(invoice.dueDate)),
    amount: `${invoice.amount.toFixed(2)} ${invoice.currency}`,
    amountPaid: `${invoice.amountPaid.toFixed(2)} ${invoice.currency}`,
    status: {
        translate: invoiceStatusMapper(invoice.status),
        value: invoice.status,
    },
});
